import { useState } from 'react';

import FormField, { FormFieldProps } from './FormField';
import TextArea, { TextAreaProps } from './TextArea';

type Props = Omit<TextAreaProps, 'hasError'> &
  Omit<FormFieldProps, 'children'> & {
    maxLength?: number;
    showCharacterCount?: boolean;
  };

const TextAreaField = ({
  label,
  hint,
  error,
  id,
  className,
  maxLength,
  showCharacterCount = false,
  ...props
}: Props) => {
  const [charCount, setCharCount] = useState(props.value?.toString().length || 0);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCharCount(e.target.value.length);
    if (props.onChange) {
      props.onChange(e);
    }
  };

  return (
    <FormField
      label={label}
      hint={hint}
      error={error}
      id={id}
      disabled={props.disabled}
      className={className}
    >
      <div className="flex flex-col">
        <TextArea hasError={!!error} id={id} {...props} onChange={handleChange} />
        {showCharacterCount && (
          <div className="text-xs mt-1 text-right text-neutral-500">
            {charCount}/{maxLength || 1000}
          </div>
        )}
      </div>
    </FormField>
  );
};

export default TextAreaField;
